module.exports = __webpack_public_path__ + "img/3_graph.f34353c0.svg";